import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import './Principal.css';

function Principal() {
  return (
    <>
      <Header />
      <main className="principal-content">
        <Outlet />
      </main>
    </>
  );
}

export default Principal;
